// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 4238 ? "hero-badge-3d" : chunkId) + "." + __webpack_require__.h() + ".js";
};